<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :title="title"
    :size="'xl'"
    :centered="true"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <div class="modal-body">
      <!-- Sección de datos del cliente -->
      <CRow class="">
        <CCol sm="12">
          <h6 class="font-weight-bold">
            <i class="fas fa-user"></i> DATOS DEL CLIENTE
          </h6>
        </CCol>
        <CCol sm="12" lg="4">
          <CInput
            label="Documento de cliente"
            placeholder="Digite documento"
            v-model="sale_new.entity_document"
            @keypress.enter="mtdSearchClientByDniOrCE"
          />
        </CCol>
        <CCol sm="12" lg="8">
          <CInput
            label="Nombre Cliente"
            placeholder="nombre"
            v-model="sale_new.entity_name"
            disabled
          />
        </CCol>
      </CRow>

      <!-- Sección específica de delivery -->
      <CRow class="mt-2">
        <CCol sm="12">
          <h6 class="font-weight-bold">
            <i class="fas fa-map-marker-alt"></i> DATOS DE ENTREGA
          </h6>
        </CCol>
        <CCol sm="12" lg="3">
          <CInput
            label="Monto de envio"
            placeholder="0"
            v-model="sale_new.amount_send"
          />
        </CCol>
        <CCol sm="12" lg="3">
          <CInput
            label="Teléfono de contacto"
            placeholder="Digite teléfono"
            v-model="sale_new.delivery_phone"
          />
        </CCol>
        <CCol sm="12" lg="6">
          <CInput
            label="Dirección de entrega"
            placeholder="Digite dirección completa"
            v-model="sale_new.delivery_address"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Referencia (opcional)"
            placeholder="Ej: Casa de 2 pisos, portón verde"
            v-model="sale_new.delivery_reference"
          />
        </CCol>
      </CRow>

      <!-- Payment processing removed - will be handled in CXC -->
    </div>
    <template #footer>
      <button @click="mtdClose" class="btn btn-danger">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </button>
      <button
        @click="mtd_action"
        :disabled="cpButton"
        class="btn btn-info btn-info"
      >
        <i class="fas fa-motorcycle"></i>&nbsp;Registrar Delivery Pendiente
      </button>
      &nbsp;
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "c-delivery-sale-modal",
  components: {
    CModal,
  },
  data() {
    return {
      prefix: "delivery",
      sale_new: {},
      isRUCValid: true,
    };
  },
  props: {
    title: String,
    productList: {
      type: Array,
      required: true,
    },
    sale: {
      type: Object,
      required: true,
    },
    boo_modal: Boolean,
  },
  watch: {
    boo_modal(newVal) {
      if (newVal) {
        this.sale_new = { ...this.sale };
      }
    },
  },
  computed: {
    cpButton() {
      return (
        !this.sale_new.entity_document ||
        !this.sale_new.entity_name ||
        !this.sale_new.delivery_phone ||
        !this.sale_new.delivery_address
      );
    },
  },

  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("closeModalSale");
    },
    mtd_action: async function () {
      let boo = this.mtdVerifDataSale();
      if (boo) {
        this.sale_new.date = moment().format("YYYY-MM-DD HH:mm:ss");
        this.sale_new.type = 2; // type = 2 para delivery
        this.sale_new.adjustment = 0; // No adjustments at delivery
      }
      let resWsp = [];
      let nameWsp = "";
      await this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/store",
        token: this.$store.getters.get__token,
        params: {
          sale: this.sale_new,
          saleDetail: this.productList,
          // No charge or turned parameters - payment handled in CXC
        },
      }).then((response) => {
        let color = "";
        let message = "";

        if (response.statusCode == 200 && response.data.data_sale !== null) {
          if (
            response.data.state == 1 ||
            response.data.state == 2 ||
            response.data.state == 3
          ) {
            message = response.message;
            Swal.fire({
              title: message,
              icon: "error",
            });
          } else {
            color = "success";
            message = "DELIVERY REGISTRADO CORRECTAMENTE";
            resWsp = response;
            nameWsp = this.sale_new.entity_name;
          }
        } else {
          color = "error";
          message = "error";
        }
        this.resetFormData();
        this.$emit("save");
        if (color == "success") {
          this.mtdProccessSaleResponse(resWsp, nameWsp,response.data.data_sale_detail);
        } else {
          Swal.fire({
            title: message,
            icon: color,
          });
        }
      });
    },
    resetFormData() {
      this.sale_new = {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        date: "",
        type: 2,
        total: "",
        amount: 0,
        pending: 0,
        adjustment: 0,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        delivery_address: "",
        delivery_reference: "",
        delivery_phone: "",
        amount_send:"",
      };
    },
    mtdSearchClientByDniOrCE() {
      if (this.sale_new.entity_document.length === 0) {
        Swal.fire({
          title: "El número de documento no debe estar vacío",
          icon: "error",
        });
        return;
      }

      let documentLength = this.sale_new.entity_document.length;

      switch (documentLength) {
        case 8:
          this.mtdSearchClientByDni();
          break;
        case 9:
          this.mtdSearchClientByCE();
          break;
        default:
          this.sale_new.entity_name = "";
          this.sale_new.entity_address = "";
          break;
      }
    },
    mtdSearchClientByDni: async function () {
      await this.get({
        url: `${this.$store.getters.get__url}/Consultas/${this.sale_new.entity_document}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.data.boo === 3) {
          this.sale_new.entity_document = "";
          this.sale_new.entity_name = "";
          this.sale_new.entity_address = "";

          Swal.fire({
            title: "DNI no encontrado",
            icon: "warning",
          });
        } else {
          this.sale_new.entity_name =
            response.data.name + " " + response.data.last_name;
          this.sale_new.entity_address = response.data.direccion ?? "";
        }
      });
    },
    mtdSearchClientByCE: function () {
      this.get({
        url: `${this.$store.getters.get__url}/Consultas/searchCe/${this.sale_new.entity_document}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode !== 200) {
          Swal.fire({
            title: "Documento no encontrado",
            icon: "warning",
          });
          this.sale_new.entity_document = "";
          this.sale_new.entity_name = "";
          this.sale_new.entity_address = "";
          return;
        }

        this.sale_new.entity_name = response.data.name;
      });
    },
    mtdSearchClientByNumberRuc: async function () {
      if (this.sale_new.entity_document.length !== 11) {
        Swal.fire({
          title: "El número de RUC debe tener 11 dígitos",
          icon: "error",
        });
        return;
      }

      await this.get({
        url:
          this.$store.getters.get__url +
          "/Consultas/" +
          this.sale_new.entity_document,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.data.boo === 3) {
          this.sale_new.entity_document = "";
          this.sale_new.entity_name = "";
          this.sale_new.entity_address = "";
          Swal.fire({
            title: "RUC no encontrado",
            icon: "warning",
          });
        } else {
          this.sale_new.entity_name = response.data.razon_social;
          this.sale_new.entity_address = response.data.direccion ?? "";
        }
      });
    },
    mtdVerifDataSale: function () {
      let boo = true;

      if (this.productList.length <= 0) {
        Swal.fire({
          title: "No tiene productos en el carrito de venta.",
          icon: "error",
        });
        boo = false;
      }

      if (!this.sale_new.delivery_phone) {
        Swal.fire({
          title: "Debe ingresar un teléfono de contacto",
          icon: "error",
        });
        boo = false;
      }

      if (!this.sale_new.delivery_address) {
        Swal.fire({
          title: "Debe ingresar una dirección de entrega",
          icon: "error",
        });
        boo = false;
      }

      if (
        this.sale_new.entity_document == "" ||
        this.sale_new.entity_name == ""
      ) {
        Swal.fire({
          title: "Agregue datos del cliente",
          icon: "error",
        });
        boo = false;
      }

      return boo;
    },
    mtdProccessSaleResponse: async function (response, name,detail) {
      // Delivery registered successfully - no voucher generation at this stage
       const ids = detail.map((item) => item.id).join(",");
        window.open(
          `${this.$store.getters.get__url}/mozo/commandnew/0/${ids}`,
          "_blank"
        );
      Swal.fire({
        title: "¡Delivery Generado Exitosamente!",
        text: "El delivery ha sido registrado correctamente. El pago se procesará en la pantalla de CXC.",
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    },
  },
};
</script>

<style scoped>
.bg-purple {
  background-color: #926cdc;
}

.bg-white {
  background-color: white;
}

.bg-gris {
  background-color: #dee2e6;
}

.color-white {
  color: white;
}

.color-black {
  color: black;
}

.font-bold {
  font-weight: bold;
}

.container-type {
  height: 40px;
}

.container-type:hover {
  background-color: #17a2b8;
  cursor: pointer;
}

.text {
  margin: auto;
}
</style>

